import React, { Component } from 'react';
import Firebase from 'firebase/app';
import Card from '../../../components/Card/Card';
import * as styles from './styles.module.css';
import GoogleAuthButton from '../../../components/GoogleAuthButton';
import FirebaseContext from '../../../components/Firebase/context';

export default class AuthForm extends Component {
  static contextType = FirebaseContext;

  handleAuth = async () => {
    const { firebase } = this.context;
    const provider = new Firebase.auth.GoogleAuthProvider();

    firebase.auth().useDeviceLanguage();
    await firebase.auth().signInWithPopup(provider);
  };

  render() {
    return (
      <Card>
        <h1 className={styles.Title}>Log In</h1>
          <div className={styles.Wrapper}>
            <GoogleAuthButton onClick={this.handleAuth} />
          </div>
      </Card>
    );
  }
}
